import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  MyListingsTab,
  ViewMode,
  StatusFilter,
  MyListingsSelectedSort,
} from "../interfaces/myListings.interface";

/** UI-only state for my-listings page; product/listing data lives in products slice. */
export interface MyListingsState {
  activeTab: MyListingsTab;
  viewMode: ViewMode;
  searchQuery: string;
  statusFilter: StatusFilter;
  selectedSort: MyListingsSelectedSort | null;
  itemsPerPage: number;
}

const initialState: MyListingsState = {
  activeTab: "all",
  viewMode: "list",
  searchQuery: "",
  statusFilter: "All Status",
  selectedSort: null,
  itemsPerPage: 10,
};

const myListingsSlice = createSlice({
  name: "myListings",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<MyListingsTab>) => {
      state.activeTab = action.payload;
    },
    setViewMode: (state, action: PayloadAction<ViewMode>) => {
      state.viewMode = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<StatusFilter>) => {
      state.statusFilter = action.payload;
    },
    setSelectedSort: (
      state,
      action: PayloadAction<MyListingsSelectedSort | null>
    ) => {
      state.selectedSort = action.payload;
    },
    setItemsPerPage: (state, action: PayloadAction<number>) => {
      state.itemsPerPage = action.payload;
    },
  },
});

export const {
  setActiveTab,
  setViewMode,
  setSearchQuery,
  setStatusFilter,
  setSelectedSort,
  setItemsPerPage,
} = myListingsSlice.actions;

export default myListingsSlice.reducer;
